import { APP_VERSION } from '@otryad/shared';

/**
 * Sentry в Mini App (BLUEPRINT Stage 15, задача 2). Подключается только при `VITE_SENTRY_DSN`
 * и динамическим импортом — в основной бандл SDK не попадает (бюджет 250 KB gz на первый экран).
 * Персональных данных не шлём: initData и пользователь в события не попадают (`sendDefaultPii: false`).
 */
export async function initMonitoring(app: 'web' | 'admin'): Promise<void> {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  try {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn,
      release: `otryad-${app}@${APP_VERSION}`,
      environment: import.meta.env.MODE,
      sendDefaultPii: false,
      tracesSampleRate: 0,
      beforeSend(event) {
        // Заголовок Authorization с initData никогда не должен уйти наружу
        if (event.request?.headers) delete event.request.headers['Authorization'];
        return event;
      },
    });
  } catch (err) {
    console.warn('Sentry не подключился', err);
  }
}
